module.exports = __webpack_public_path__ + "media/images/icons/connect-6b643621147e6a8c65a2a1a731111039.svg";